
define('ldsh!modules/editor/templates/elements/video_editor_amp', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div>\n    <figure>\n        <img src="' +
((__t = ( assetsHost )) == null ? '' : __t) +
'imgs/icons/video-placeholder.png"\n             alt="Video Placeholder">\n        <span class="js-videocontent" style="display: none;"></span>\n        <figcaption>\n            <small class="video--caption block f10"\n                data-i18n="editor.video.noPreview"></small>\n        </figcaption>\n    </figure>\n</div>\n';

}
return __p
};});

